import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'catalogos/periodicidad-de-pago-de-nomina';

/**
 * GET Periodicidades Pagos Nominas
 * @returns {Promise<object[]>}
 */
export const getPeriodicidadesPagosNominas = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Periodicidad Pago Nomina
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getPeriodicidadPagoNomina = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Periodicidad Pago Nomina
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postPeriodicidadPagoNomina = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Periodicidad Pago Nomina
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchPeriodicidadPagoNomina = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Periodicidad Pago Nomina
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deletePeriodicidadPagoNomina = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
